import React, { useState, useContext, useEffect } from "react";
import styles from "../CreateProduct/CreateProductModal.module.css";
import { editProductFromDatabase } from "../../../hooks/Product";
import { ProductContext } from '../../../context/ProductContext';
import { FaChevronDown } from "react-icons/fa";
import { GetStoreIds } from '../../../utils/GetStoreIds';

function Modal({ closeModal }) {
  const { 
    editProduct, 
    selectedProduct
   } = useContext( ProductContext );

  const [barCode, setBarCode] = useState(selectedProduct[0]?.barcode || "");
  const [productName, setProductName] = useState(selectedProduct[0]?.name || "");
  const [manufacturer, setManufacturer] = useState(selectedProduct[0]?.manufacturer || "");
  const [group, setGroup] = useState(selectedProduct[0]?.group || "");
  const [stores, setStores] = useState([]);
  const [storeIds, setStoreIds] = useState([]);
  const [selectedStores, setSelectedStores] = useState([]);
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);

  const toggleStoreDropdown = () => { setIsStoreDropdownOpen(!isStoreDropdownOpen) };
  const onEditClick = async (e) => {
    e.preventDefault(); 
    const productData = {
      id : selectedProduct[0]?.id || 0,
      barcode : barCode, 
      name: productName, 
      manufacturer: manufacturer, 
      group : group,
      storeIds : storeIds
  };
    const response = await editProductFromDatabase( productData );
    if (response) { 
      editProduct(true);
      closeModal();
    } else {
      editProduct(false);
      closeModal();
    }
  };

  const handleToggleStoreSelection = ( store ) => {
    setSelectedStores(( prevSelectedStores ) => {
      if (prevSelectedStores.some((s) => s.id === store.id)) {
        return prevSelectedStores.filter((s) => s.id !== store.id);
      } else {
        return [...prevSelectedStores, store];
      }
    });
  };

  useEffect(() => {
    if (selectedProduct[0]?.stores?.length > 0) {
      const stores = selectedProduct[0]?.stores
      setSelectedStores(stores);
      setStores(stores)
    }
  }, [selectedProduct])

  useEffect(() => {
    setStoreIds(GetStoreIds(selectedStores));
}, [ selectedStores ]);
  
  const renderStoresDropdown = () => {
    return (
      <>
        <button 
        type="button" 
        onClick={ toggleStoreDropdown } 
        className={styles.dropdownButton}>Loja<FaChevronDown className={styles.icon} />  </button>  
      </>
    )
  }

  const isFormValid = barCode && productName && manufacturer && group && storeIds;
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Código de Barras</span>
              <input
                type="text"
                required
                placeholder="Digite o código de barras do produto"
                value={ barCode }
                onChange={(e) => setBarCode(e.target.value)}
              />
            </label>

            <label>
              <span>Nome do Produto</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do produto"
                value={ productName }
                onChange={(e) => setProductName(e.target.value)}
              />
            </label>

            <label>
              <span>Fabricante</span>
              <input
                type="text"
                required
                placeholder="Digite o nome do fabricante"
                value={ manufacturer }
                onChange={ (e) => setManufacturer(e.target.value)}
                maxLength="18"
              />
            </label>

            <label>
              <span>Grupo</span>
              <input
                type="text"
                required
                placeholder="Digite o grupo do produto"
                value={ group }
                onChange={(e) => setGroup(e.target.value)}
              />
            </label>

            <label>
              <span>Loja</span>
                <div className={styles.dropdown}>

                {renderStoresDropdown()}

                { isStoreDropdownOpen && (
                  <div className={styles.dropdownContent}>
                        {stores.map((store) => (
                          <div key={store.id} className={styles.storeItem}>
                            <div className={styles.checkboxLabel}>
                              <input 
                                  type="checkbox"
                                  checked={ selectedStores.some((s) => s.id === store.id)}
                                  onChange={() => handleToggleStoreSelection(store)}
                                />
                            </div>
                              
                            <span>{store.name}</span>
                          </div>
                        ))}
                    </div>
                )}
                
              </div>
            </label>
          </form>
        </div>
        <div className={styles.buttonContent}>
          <button 
            onClick={ onEditClick } 
            className={styles.buttonConfirm}
            disabled={!isFormValid}>
            Editar Produto
          </button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
